import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=ef44fc64&scoped=true&"
import script from "./CustomFields.vue?vue&type=script&lang=js&"
export * from "./CustomFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=ef44fc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef44fc64",
  null
  
)

export default component.exports